module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/2.b5c1fee0.png";